import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import SelectContent from './SelectContent.tsx';
// import CardAlert from './CardAlert.tsx';
import MenuContent from './MenuContent.tsx';
import OptionsMenu from './OptionsMenu.tsx';
import logo from '../../../assets/casper-logo.png';
import logo_dark from '../../../assets/casper-logo-dark.png';
import { useColorScheme } from '@mui/material/styles';
import { useAuth } from '../../../context/AuthContext.tsx';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
};

export default function SideMenu() {
  const { mode } = useColorScheme();
  const { userData } = useAuth();

  const formatarTelefone = (telefone) => {
    const apenasNumeros = telefone.replace(/\D/g, "");

    if (apenasNumeros.length === 11) {
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7)}`;
    }
  
    if (apenasNumeros.length === 10) {
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 6)}-${apenasNumeros.slice(6)}`;
    }
    
    return telefone
  };

  const name = userData?.clI_NOME === '' ? "Nome não informado..." : userData?.clI_NOME;
  const phone = !userData?.clI_RESTELEFONE
  ? "Fone não informado..."
  : formatarTelefone(userData.clI_RESTELEFONE);

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 2.5,
          '& img': {
            width: { xs: '100px', sm: '120px', md: '150px' }, 
            height: 'auto',
          }
        }}
      >
        <img  src={mode === 'dark' ? logo_dark : logo} alt="logo sulpasso" />
      </Box>
      <Divider />
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent />
      </Box>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Avatar {...stringAvatar(name)} />
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {name.length > 11 ? name.slice(0, 11) + '...' : name}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {phone.length > 18 ? phone.slice(0, 18) : phone}
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack>
    </Drawer>
  );
}
